module.exports = __webpack_public_path__ + "img/eu_en.0f52188b.png";